<template>
    <div class="c-formElement">
        <slot name="start"/>
        <div class="c-formElement__field">
            <slot/>
        </div>
        <div
            v-if="$hasSlotContent($slots.end)"
            class="c-formElement__end"
        >
            <slot name="end"/>
        </div>
    </div>
</template>

<style lang="scss">
@use '~@karriereat/global-styles/scss/settings/spacing';

.c-formElement {
    &__field:not(:first-child) {
        margin-top: spacing.$k-spacing--xs;
    }

    &__end {
        margin-top: spacing.$k-spacing--s;
    }
}
</style>
